"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Quote = exports.QuoteDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var router_1 = require("@reach/router");
var html_1 = require("./html");
var icon_1 = require("./icon");
var person_label_1 = require("../entities/person-label");
var person_photo_1 = require("../entities/person-photo");
var use_entities_1 = require("../../hooks/use-entities");
exports.QuoteDefaultProps = {
  color: 'light',
  backgroundColor: 'primary'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    font-size: 1.1em;\n    font-weight: 300;\n    margin: 0;\n    padding: ", ";\n    padding-bottom: ", ";\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: row;\n    font-size: 1.1em;\n    font-weight: 300;\n    margin: 0;\n    padding: ", ";\n    padding-bottom: ", ";\n\n    ", "\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), function (props) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      background-color: ", ";\n    "], ["\n      color: ", ";\n      background-color: ", ";\n    "])), theme_1.theme.COLOR(props.color), theme_1.theme.COLOR(props.backgroundColor));
  }),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1.3em;\n    padding: ", ";\n    padding-bottom: ", ";\n  "], ["\n    font-size: 1.3em;\n    padding: ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(6), theme_1.theme.UNIT(6)),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1.5em;\n    padding: ", ";\n    padding-bottom: ", ";\n  "], ["\n    font-size: 1.5em;\n    padding: ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(10), theme_1.theme.UNIT(10))
});
var QuoteStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: 700;\n    font-size: ", ";\n    flex-shrink: 0;\n  "], ["\n    font-weight: 700;\n    font-size: ", ";\n    flex-shrink: 0;\n  "])), theme_1.theme.FONT_SIZE(44)),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var OpenStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n    position: relative;\n    top: 14px;\n  "], ["\n    ", "\n    position: relative;\n    top: 14px;\n  "])), QuoteStyles)
});
var CloseStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n    align-self: flex-end;\n  "], ["\n    ", "\n    align-self: flex-end;\n  "])), QuoteStyles)
});
var HTMLStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    line-height: ", ";\n    padding: 0 ", ";\n    p {\n      margin-top: 0;\n      margin-bottom: 1em;\n\n      &:last-child {\n        margin-bottom: 0.25em;\n      }\n    }\n  "], ["\n    line-height: ", ";\n    padding: 0 ", ";\n    p {\n      margin-top: 0;\n      margin-bottom: 1em;\n\n      &:last-child {\n        margin-bottom: 0.25em;\n      }\n    }\n  "])), theme_1.theme.LINE_HEIGHT('copy-tight'), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), theme_1.theme.UNIT(6))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 75%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 75%;\n  "])))
});
var PersonLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    padding: ", " 0;\n    font-size: ", ";\n  "], ["\n    padding: ", " 0;\n    font-size: ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.FONT_SIZE(16))
});
var PersonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    flex-basis: 25%;\n    min-width: 110px;\n  "], ["\n    flex-basis: 25%;\n    min-width: 110px;\n  "])))
});
var PersonPhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.blockquote(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Open: (0, styled_components_1.default)(icon_1.Icon)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), OpenStyles),
  Close: (0, styled_components_1.default)(icon_1.Icon)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), CloseStyles),
  HTML: (0, styled_components_1.default)(html_1.HTML)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), HTMLStyles),
  Content: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Person: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), PersonStyles),
  PersonLabel: (0, styled_components_1.default)(person_label_1.PersonLabel)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), PersonLabelStyles),
  PersonPhoto: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), PersonPhotoStyles)
};
var Quote = function (props) {
  var className = props.className,
    children = props.children,
    color = props.color,
    backgroundColor = props.backgroundColor,
    entity = props.entity;
  var entities = (0, use_entities_1.useEntities)();
  return React.createElement(My.Container, {
    color: color,
    backgroundColor: backgroundColor,
    className: className
  }, entity.person && React.createElement(My.Person, null, React.createElement(router_1.Link, {
    to: entities.Person.to(entity.person.slug)
  }, React.createElement(My.PersonPhoto, {
    size: 100,
    entity: entity.person
  })), React.createElement(My.PersonLabel, {
    entity: entity.person
  })), React.createElement(My.Open, {
    color: color
  }, "\u201C"), React.createElement(My.Content, null, React.createElement(My.HTML, {
    text: entity.description.html || entity.description.text
  })), React.createElement(My.Close, {
    color: color
  }, "\u201D"));
};
exports.Quote = Quote;
exports.Quote.defaultProps = exports.QuoteDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;